// Popup "Đồng Hồ Báo Thức": nghe voice (1 audio chạy tại 1 thời điểm), tải file,
// nhân vật chưa tới mốc release thì bấm ra thông báo thay vì phát/tải.
//
// Cách khoá: URL nằm ở bảng AUDIO bên dưới chứ không phải trong HTML, JS chỉ gắn vào thẻ
// khi hàng đó đã qua mốc. Hàng chưa tới mốc có link rỗng nên bấm không lấy được gì, và
// chính chỗ rỗng đó là tín hiệu để hiện thông báo "sẽ được cập nhật".
//
// Vẫn gom + dọn link có sẵn trong DOM vì hai lẽ: markup bên CMS lag so với git nên bản
// đang chạy có thể còn kèm URL (dọn đi cho khỏi lộ), và nếu bản đó chưa có data-file thì
// còn link vừa gom để dùng tạm — không thì deploy bundle mới là chết cả 5 nút.
//
// Mốc đọc từ data-open. CHỈ nhận đúng mẫu YYYY-MM-DD[ HH:mm[:ss]] và luôn quy về giờ VN,
// KHÔNG dùng new Date(chuỗi) thô: bản cũ làm vậy nên nếu người biên tập trên CMS gõ kiểu
// Việt Nam "02/10/2026" thì trình duyệt hiểu thành 10/02 (đã qua) và mở khoá cả loạt.
// Mọi trường hợp không đọc được -> KHOÁ, vì lỗi "chưa mở được" an toàn hơn "lộ hết".
window.addEventListener('load', function () {
  var $section = $('#cfl-ms-25-alarmclock');
  if (!$section.length) return;

  // Ngày giờ tách nhóm để tự dựng mốc, không nhờ new Date() đoán định dạng.
  // Phần giờ có thể bỏ (chỉ ghi ngày) -> hiểu là 00:00:00.
  var OPEN_PATTERN = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?)?$/;
  var VN_OFFSET_MS = 7 * 60 * 60 * 1000; // mốc luôn tính theo giờ VN dù máy ở múi giờ nào

  // Tra theo data-file trong markup. Ghi literal từng URL đầy đủ (không ghép chuỗi) để
  // plugin optimize nhận diện được và không coi mấy file mp3 này là không dùng tới.
  var AUDIO = {
    'alarm-xiao-yi': 'https://cdn-mainsite-aka.vnggames.com/products/lan/2026-mainsite/music/alarm-xiao-yi.mp3',
    'alarm-lu-chen': 'https://cdn-mainsite-aka.vnggames.com/products/lan/2026-mainsite/music/alarm-lu-chen.mp3',
    'alarm-qi-sili': 'https://cdn-mainsite-aka.vnggames.com/products/lan/2026-mainsite/music/alarm-qi-sili.mp3',
    'alarm-zha-lisu': 'https://cdn-mainsite-aka.vnggames.com/products/lan/2026-mainsite/music/alarm-zha-lisu.mp3',
    'alarm-xia-mingxing': 'https://cdn-mainsite-aka.vnggames.com/products/lan/2026-mainsite/music/alarm-xia-mingxing.mp3'
  };

  var audio = new Audio();
  var $playing = null;
  var $notice = $section.find('.notice');
  var noticeTimer = null;
  var clockSkew = 0; // giờ server - giờ máy, để chỉnh giờ máy cũng không mở sớm được

  // Toast nổi GIỮA popup: hiện lên rồi tự ẩn. Không bám theo hàng vừa bấm — bấm hàng nào
  // cũng thấy ở cùng một chỗ dễ nhìn, không che nội dung hàng bên cạnh.
  function showNotice() {
    $notice.removeClass('active');
    // ép reflow để lần bấm liên tiếp chạy lại animation từ đầu thay vì đứng im
    void $notice[0].offsetWidth;
    $notice.addClass('active');
    clearTimeout(noticeTimer);
    noticeTimer = setTimeout(function () {
      $notice.removeClass('active');
    }, 2000);
  }

  // Trả về epoch ms của mốc, hoặc NaN nếu chuỗi sai mẫu / ngày không có thật (31/02...).
  function parseOpen(raw) {
    var m = OPEN_PATTERN.exec($.trim(raw || ''));
    if (!m) return NaN;
    var y = +m[1], mo = +m[2], d = +m[3], h = +(m[4] || 0), mi = +(m[5] || 0), s = +(m[6] || 0);
    if (mo < 1 || mo > 12 || d < 1 || d > 31 || h > 23 || mi > 59 || s > 59) return NaN;
    var utc = Date.UTC(y, mo - 1, d, h, mi, s);
    // Date.UTC tự cuộn 2026-02-31 thành 03/03 — so ngược lại để loại ngày không tồn tại
    var back = new Date(utc);
    if (back.getUTCFullYear() !== y || back.getUTCMonth() !== mo - 1 || back.getUTCDate() !== d) {
      return NaN;
    }
    return utc - VN_OFFSET_MS;
  }

  function now() {
    return Date.now() + clockSkew;
  }

  // Cất link có sẵn trong markup vào bộ nhớ JS ($.data không ghi ra thuộc tính) rồi xoá
  // sạch khỏi DOM. Chạy MỘT lần lúc load, trước khi trả link lại cho hàng đã tới mốc.
  function harvestLinks() {
    $section.find('.item').each(function () {
      var $item = $(this);
      var $download = $item.find('.btn-download');
      var url = $.trim($item.attr('data-audio') || $download.attr('href') || '');
      $item.data('audioUrl', /\.mp3(\?|#|$)/i.test(url) ? url : '');
      $item.removeAttr('data-audio');
      $download.removeAttr('href').removeAttr('download');
    });
  }

  function isOpen($item) {
    var time = parseOpen($item.attr('data-open'));
    if (isNaN(time)) return false; // sai mẫu -> khoá
    return now() >= time;
  }

  // Bảng AUDIO là nguồn chính; link gom từ DOM chỉ để đỡ cho markup CMS chưa có data-file.
  function sourceUrl($item) {
    return AUDIO[$.trim($item.attr('data-file') || '')] || $item.data('audioUrl') || '';
  }

  // Link dùng được của hàng này: rỗng nghĩa là chưa tới mốc (hoặc không tra ra URL nào).
  function readyUrl($item) {
    return isOpen($item) ? sourceUrl($item) : '';
  }

  // Trả link lại cho hàng đã qua mốc, gỡ khỏi hàng chưa tới. Chạy lại được nhiều lần
  // (sau khi đồng bộ giờ server, và mỗi phút một lần để trang mở sẵn qua mốc tự mở khoá).
  function applyState() {
    $section.find('.item').each(function () {
      var $item = $(this);
      var $download = $item.find('.btn-download');
      var url = readyUrl($item);
      if (url) {
        $download.attr('href', url).attr('download', url.split('/').pop().split(/[?#]/)[0]);
        $item.addClass('is-open');
      } else {
        $download.removeAttr('href').removeAttr('download');
        $item.removeClass('is-open');
      }
    });
  }

  // Lấy giờ server từ header Date của chính trang. Hỏng thì im lặng dùng giờ máy —
  // chặn được người chỉnh đồng hồ là phần thêm, không phải điều kiện để trang chạy.
  function syncClock() {
    if (!window.fetch) return;
    fetch(window.location.href, { method: 'HEAD', cache: 'no-store' })
      .then(function (res) {
        var raw = res.headers.get('date');
        if (!raw) return;
        var t = new Date(raw).getTime();
        if (isNaN(t)) return;
        clockSkew = t - Date.now();
        applyState();
      })
      .catch(function () {});
  }

  function stopAudio() {
    audio.pause();
    audio.currentTime = 0;
    if ($playing) $playing.removeClass('playing');
    $playing = null;
  }

  $section.on('click', '.btn-listen', function (e) {
    e.preventDefault();
    var $btn = $(this);
    var $item = $btn.closest('.item');
    var url = readyUrl($item);
    if (!url) {
      // link rỗng = chưa tới ngày -> báo "sẽ được cập nhật"
      stopAudio();
      showNotice();
      return false;
    }
    // bấm lại đúng nút đang phát -> dừng
    if ($playing && $playing[0] === $btn[0]) {
      stopAudio();
      return false;
    }
    stopAudio();
    audio.src = url;
    var promise = audio.play();
    if (promise && promise.catch) promise.catch(function () {});
    $playing = $btn.addClass('playing');
    return false;
  });

  $section.on('click', '.btn-download', function (e) {
    if (!readyUrl($(this).closest('.item'))) {
      e.preventDefault();
      showNotice();
      return false;
    }
  });

  audio.addEventListener('ended', stopAudio);
  $section.find('.MJ__close-popup').on('click', stopAudio);

  harvestLinks();
  applyState();
  syncClock();
  setInterval(applyState, 60000);
});
